<template>
  <div class="search-field">
    <form
      class="d-flex align-items-center justify-content-end"
      method="get"
      :action="getLink('searchPage')"
      @submit.prevent="onSearch"
    >
      <div
        v-if="
          !$mqAliases.desktop ||
          viewSearchBoxDesktop ||
          !triggerSearchBox ||
          searchBoxStyle === 'inline'
        "
        class="w-100 d-flex align-items-center"
      >
        <input
          ref="search"
          type="search"
          name="searchtext"
          class="search-field-field"
          :placeholder="placeHolderText"
          autocomplete="off"
          :aria-autocomplete="triggerSearchBox"
          :role="triggerSearchBox ? 'combobox' : ''"
          :aria-controls="triggerSearchBox ? 'mainSearchBox' : ''"
          :aria-label="insertString('Global', 'HeaderSearch', 'Placeholder')"
          :value="inputValue"
          @input="onInput"
          @change="$emit('change', $event.target.value)"
          @focus="onFocus(true)"
          @blur="onBlur()"
          @click="searchStarted"
        />
        <div class="search-field-clear" @click="clearField()">
          <Icon
            :icon="{
              name: 'Cancel',
              color: Globals.colors.primary,
              size: 18,
            }"
          />
        </div>
      </div>
      <button
        class="btn -stripped search-field-icon"
        tabindex="0"
        title="Search"
        @click.prevent="toggleSearch()"
      >
        <Icon
          class="search-field-icon-svg"
          :icon="{
            name: 'search',
            color: Globals.colors.primary,
            size: $mqAliases.desktop ? 18 : 21,
          }"
        />
      </button>
    </form>
  </div>
</template>
<script>
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import Icon from '@/Scripts/components/shared/svg/Svg.vue';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import { TrackerSearch, TrackerSearchStarted } from '@/Scripts/lib/helper/trackingHelper.js';
import searchHelper from '@/Scripts/components/layout/Search/searchHelper.js';

export default {
  mixins: [siteInfo],
  components: {
    Icon
  },
  model: {
    prop: 'searchText',
    event: 'change'
  },
  props: {
    searchText: String,
    triggerSearchBox: {
      type: Boolean,
      default: true
    },
    searchBoxStyle: String
  },
  data: function () {
    return {
      viewSearchBoxDesktop: false,
      isFocus: false,
      isEmpty: true,
      inputValue: this.searchText,
      searchHistoryToken: 'search_string'
    };
  },
  watch: {
    viewSearchBoxDesktop (val) {
      if (val) {
        eventBus.$emit('SEARCH_VIEW_SEARCHBOX', { val: true, type: this.searchBoxStyle });
        this.$nextTick(() => {
          this.setFocus();
        });
      }
    }
  },
  computed: {
    placeHolderText () {
      if (this.isFocus) {
        return this.insertString('Global', 'HeaderSearch', 'FocusPlaceholder');
      }
      return this.insertString('Global', 'HeaderSearch', 'Placeholder');
    }
  },
  methods: {
    // Sets focus on the search field when clicking on the search icon
    setFocus () {
      if (this.$refs.search) {
        this.$refs.search.focus();
      }
    },

    clearField () {
      this.inputValue = '';
      this.$emit('focus', false);
      if (this.triggerSearchBox) {
        eventBus.$emit('SEARCH_VIEW_SEARCHBOX', { val: false, type: this.searchBoxStyle });
      }
    },
    onInput ($event) {
      this.inputValue = $event.target.value;
      if (this.triggerSearchBox) {
        eventBus.$emit('SEARCH_FIELD_INPUT', this.inputValue);
      }
    },
    onFocus (val) {
      this.isFocus = val;
      this.$emit('focus', val);
      if (this.triggerSearchBox) {
        eventBus.$emit('SEARCH_VIEW_SEARCHBOX', { val: val, type: this.searchBoxStyle });
      }
    },
    onBlur () {
      this.isFocus = false;
    },
    onSearch () {
      TrackerSearch(this.searchText);
      searchHelper.writeSearchHistory(this.searchText);
      eventBus.$emit('SEARCH_FIELD_ONSEARCH');
      window.location.href = searchHelper.getSearchPageLink(this.searchText);
    },
    searchStarted () {
      TrackerSearchStarted();
    },
    toggleSearch () {
      this.searchStarted();
      // TODO: make code more readable
      if (this.triggerSearchBox) {
        if ((this.$mqAliases.desktop && this.inputValue === '') || !this.viewSearchBoxDesktop) {
          this.viewSearchBoxDesktop = true;
        } else {
          if (this.inputValue !== '') {
            this.onSearch();
          }
        }
      } else {
        // if searchbox disabled, just search
        if (this.inputValue !== '') {
          this.onSearch();
        }
      }
    }
  },
  created () {
    eventBus.$on('SEARCH_VIEW_SEARCHBOX', obj => {
      if (!obj.val) {
        this.inputValue = '';
        this.$emit('focus', false);
        if (this.$mqAliases.desktop) {
          this.viewSearchBoxDesktop = false;
        }
      }
    });
  }
};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";

.search-field {
  margin: 0 -9px;
  padding: 0 9px;
  background-color: $white;
  &-icon {
    padding: 0 9px;
  }
  form input {
    position: relative;
     z-index: 100;
    //  background-color: white;
  }
  &-icon {
    //padding-right: 0;
    cursor: pointer;
    &-svg {
      pointer-events: none;
    }
  }

  @include media-breakpoint-up(md) {
    margin: 0 -12px;
    padding: 0 12px;
    .search-field-icon {
      padding: 0 12px;
    }
  }

  @include media-breakpoint-up(lg) {
    width: 100%;
    min-width: auto;
    margin: 0;
    padding: 0;
    .search-field-icon {
      padding: 0;
    }
  }

  input {
    @include font-responsive(large);
    display: inline-block;
    width: 100%;
    height: $main-navigation-drawer-height;
    color: inherit;
    background: transparent;
    outline: none;
    border: none;
    padding: 0 9px;
    margin: 0;
    box-shadow: none;
    vertical-align: middle;
    .main-header & {
      padding: 0;
    }
    &::placeholder {
      color: $gray-dark;
    }
    .-transparent-header & {
      &::placeholder {
        color: inherit;
      }
    }
    &::-webkit-search-cancel-button {
      visibility: hidden;
      -webkit-appearance: none;
    }
    & + .search-field-clear {
      position: relative;
      left: -18px;
      visibility: visible;
      @include media-breakpoint-up(lg) {
        display: none;
      }
    }
    &:placeholder-shown + .search-field-clear {
      visibility: hidden;
    }
  }

  .-black-theme & {
    @include media-breakpoint-up(lg) {
      input,
      form {
        //color: $white;
        // background-color: $black !important;
      }
    }
  }
}
</style>
